/**
 * @see https://loiane.com/2017/08/angular-tips-formatting-dates-with-a-custom-date-pipe-dd-mm-yyyy/
 *
 * This is a custom Date pipe
 *
 */
import * as tslib_1 from "tslib";
// Core packages
import { DatePipe } from "@angular/common";
import { PipeTransform } from "@angular/core";
// Third party packages
import moment from 'moment';
// Custom packages
import { ConfigService } from "../services/config.service";
/**
 * Date only format
 */
var TimeFormatPipe = /** @class */ (function (_super) {
    tslib_1.__extends(TimeFormatPipe, _super);
    function TimeFormatPipe(configService) {
        var _this = _super.call(this, "en-US") || this;
        _this.configService = configService;
        return _this;
    }
    TimeFormatPipe.prototype.transform = function (value, args) {
        // return super.transform(value, Constants.DATE_FMT);
        return _super.prototype.transform.call(this, value, this.configService.timeFormat);
    };
    return TimeFormatPipe;
}(DatePipe));
export { TimeFormatPipe };
/**
 * Date only format
 */
var DateFormatPipe = /** @class */ (function (_super) {
    tslib_1.__extends(DateFormatPipe, _super);
    function DateFormatPipe(configService) {
        var _this = _super.call(this, "en-US") || this;
        _this.configService = configService;
        return _this;
    }
    DateFormatPipe.prototype.transform = function (value, args) {
        // return super.transform(value, Constants.DATE_FMT);
        return _super.prototype.transform.call(this, value, this.configService.dateFormat);
    };
    return DateFormatPipe;
}(DatePipe));
export { DateFormatPipe };
/**
 * Date + time format
 */
var DateTimeFormatPipe = /** @class */ (function (_super) {
    tslib_1.__extends(DateTimeFormatPipe, _super);
    function DateTimeFormatPipe(configService) {
        var _this = _super.call(this, "en-US") || this;
        _this.configService = configService;
        return _this;
    }
    DateTimeFormatPipe.prototype.transform = function (value, args) {
        // return super.transform(value, Constants.DATE_TIME_FMT);
        return _super.prototype.transform.call(this, value, this.configService.dateTimeFormat);
    };
    return DateTimeFormatPipe;
}(DatePipe));
export { DateTimeFormatPipe };
/**
 * Date document format:
 */
var DateDocumentFormatPipe = /** @class */ (function (_super) {
    tslib_1.__extends(DateDocumentFormatPipe, _super);
    function DateDocumentFormatPipe(configService) {
        var _this = _super.call(this, "it-It") || this;
        _this.configService = configService;
        return _this;
    }
    DateDocumentFormatPipe.prototype.transform = function (value, args) {
        // return super.transform(value, Constants.DATE_TIME_FMT);
        var transformDate = value;
        if (RegExp(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, "i").test(value) && moment(value).isValid()) {
            transformDate = _super.prototype.transform.call(this, value);
        }
        return transformDate;
    };
    return DateDocumentFormatPipe;
}(DatePipe));
export { DateDocumentFormatPipe };
/**
 * Date document format:
 */
var MinutesToHoursPipe = /** @class */ (function () {
    function MinutesToHoursPipe() {
    }
    MinutesToHoursPipe.prototype.transform = function (value, args) {
        var hours = Math.floor(value / 60);
        var minutes = Math.floor(value % 60);
        return hours + "h " + minutes + "m";
    };
    return MinutesToHoursPipe;
}());
export { MinutesToHoursPipe };
